import { render, staticRenderFns } from "./BrandManageButtons.vue?vue&type=template&id=e08070c0&"
import script from "./BrandManageButtons.vue?vue&type=script&lang=ts&"
export * from "./BrandManageButtons.vue?vue&type=script&lang=ts&"
import style0 from "./BrandManageButtons.vue?vue&type=style&index=0&id=e08070c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports